// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"PantryToolTipCommon_tooltipWrapper__l5mPs","tooltip":"PantryToolTipCommon_tooltip__g_Bd5","arrow":"PantryToolTipCommon_arrow__DBSF2"};